import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import logo from '../images/logo.png';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  z-index: 9999;
  animation: ${props => props['data-fading'] === 'true' ? fadeOut : 'none'} 0.8s ease-out forwards;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${fadeIn} 1.5s ease-out;
`;

const Logo = styled.img`
  max-width: 200px;
  height: auto;
  margin-bottom: 20px;
`;

const LoadingText = styled.h2`
  color: #ffffff;
  font-family: 'Roboto', sans-serif;
  font-size: 1.5rem;
  margin-top: 20px;
`;

const Spinner = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 4px solid #4a90e2;
  animation: ${Spinner} 1s linear infinite;
  margin-top: 20px;
`;

const LoadingAnimation = ({ onLoadingComplete }) => {
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsFading(true);
      // Wait for fade out animation to complete before calling onLoadingComplete
      setTimeout(() => {
        if (onLoadingComplete) onLoadingComplete();
      }, 800); // Match the fadeOut animation duration
    }, 2500); // Total loading time

    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <LoadingContainer data-fading={isFading.toString()}>
      <LogoContainer>
        <Logo src={logo} alt="Company Logo" />
        <LoadingText>Welcome to Zyntro</LoadingText>
        <LoadingSpinner />
      </LogoContainer>
    </LoadingContainer>
  );
};

export default LoadingAnimation;